import type { CountryCode } from 'libphonenumber-js'
import type { IIconsVector } from 'shared/ui'

export const FLAG_CUSTOM_ICON_BY_COUNTRY: Partial<Record<CountryCode, IIconsVector>> = {
  US: 'flagUSA',
  CA: 'flagCanada',
  GB: 'flagUK',
  AU: 'flagAU',
}
